import { render, staticRenderFns } from "./SettingsLogsView.vue?vue&type=template&id=18054899&scoped=true&"
import script from "./SettingsLogsView.vue?vue&type=script&lang=js&"
export * from "./SettingsLogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18054899",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18054899')) {
      api.createRecord('18054899', component.options)
    } else {
      api.reload('18054899', component.options)
    }
    module.hot.accept("./SettingsLogsView.vue?vue&type=template&id=18054899&scoped=true&", function () {
      api.rerender('18054899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsLogsView.vue"
export default component.exports